import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { MoneyFormat, MoneyFormatv2 } from "../../library/MoneyFormat";
import { useThemes } from "../Theme/theme";
import { useListPlaceOfSupplyQuery } from "../../redux/apis/getCodeTranslation.api";
import { useSelector } from "react-redux";

function GroupingColumnTable({ data }) {

  const { theme } = useThemes()

  const [tableData, setTableData] = useState([])

  const { data: listOfStates } = useListPlaceOfSupplyQuery({ codetype: "IndiaState" })

  const companyDetails = useSelector(
    (state) => state.companyReducer.companyDetails
  );

  useEffect(() => {
    if (data) {
      GSTR3B2FilterData()
    }

  }, [data])

  function findPlaceOfSupplyLabel(placeOfSupply) {
    if (placeOfSupply && listOfStates) {
      const stateLabel = listOfStates?.find(
        (ele) => ele.statecode === parseInt(placeOfSupply)
      )?.statename;
      return stateLabel;
    }
    return ""

  }

  const calculateGST = (taxValue, GSTRate) => {
    return (taxValue * GSTRate) / 100;
  };


  function GSTR3B2FilterData() {
    const uniqueData = {};
    const GSTR3BSales = data[0]?.GSTR1Data
    if (GSTR3BSales?.length > 0) {
      const result = GSTR3BSales?.filter((sales) => {
        return (
          companyDetails?.relatedaddressentity[0]?.statecode !== null &&
          sales?.placeofsupply !== null &&
          companyDetails?.relatedaddressentity[0]?.statecode !== sales?.placeofsupply
        );
      });

      result?.forEach((sales) => {
        let placeofSupply = findPlaceOfSupplyLabel(sales?.placeofsupply);
        if (
          sales?.relatedpartymaster[0]?.gstcategory === "UB" ||
          sales?.relatedpartymaster[0]?.gstcategory === "RBCS"
        ) {
          let sumOFTaxValue = sales?.relatedinvoicelineitems?.reduce(
            (acc, value) => acc + value.itemrate * value.quantity,
            0
          );
          let sumOFGst = sales?.relatedinvoicelinegst.reduce(
            (acc, value) => acc + value.gstrate,
            0
          );

          if (!uniqueData[placeofSupply]) {
            uniqueData[placeofSupply] = {
              placeOfSupply: placeofSupply,
              taxValueUB: 0,
              taxValueRBCS: 0,
              integratedTaxUB: 0,
              integratedTaxRBCS: 0,
            };
          }
          let gstCategory = sales?.relatedpartymaster[0]?.gstcategory;
          let taxValueKey = `taxValue${gstCategory}`;
          let integratedTaxKey = `integratedTax${gstCategory}`;

          // Add taxValue and integratedTax based on the GSTCategory
          uniqueData[placeofSupply][taxValueKey] += sumOFTaxValue;
          uniqueData[placeofSupply][integratedTaxKey] += calculateGST(
            sumOFTaxValue,
            sumOFGst
          );
        }
      });
      setTableData(Object.values(uniqueData));
    } else {
      setTableData([]);
    }
  }



  return (
    <Paper
      sx={{
        width: "100%",
        overflow: "hidden",
        marginTop: 3,
      }}
    >
      <Typography sx={{ paddingX: 1 }}>
        2. Details of inter-state supplies made to unregistered
        persons,composition dealer and UIN holders
      </Typography>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
                rowSpan={2}
                colSpan={1}
              >
                Place of Supply (state/UT)
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
                colSpan={2}
              >
                Supplies made to unregistered persons
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
                colSpan={2}
              >
                Supplies made to composition taxable persons
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
                colSpan={2}
              >
                Supplies made to UIN holders
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
              >
                Total taxable value
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
              >
                Amount of integrated tax
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
              >
                Total taxable value
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
              >
                Amount of integrated tax
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
              >
                Total taxable value
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFF",
                  backgroundColor: theme.palette.secondary.main,
                  textAlign: "center",
                  borderRight: 1,
                }}
              >
                Total taxable value
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData?.map((item) => {
              return (
                <TableRow>
                  <TableCell align="center">
                    {item?.placeOfSupply && item?.placeOfSupply.split(/(?=[A-Z])/)
                      .filter(part => !part.includes("District"))
                      .join(" ")}
                  </TableCell>
                  <TableCell align="center">{MoneyFormatv2(item?.taxValueUB)}</TableCell>
                  <TableCell align="center">{MoneyFormatv2(item?.integratedTaxUB)}</TableCell>
                  <TableCell align="center">{MoneyFormatv2(item?.taxValueRBCS)}</TableCell>
                  <TableCell align="center">{MoneyFormatv2(item?.integratedTaxRBCS)}</TableCell>
                  <TableCell align="center">0</TableCell>
                  <TableCell align="center">0</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default memo(GroupingColumnTable);
